/** Page-level skeleton for full-page data dependencies (not every table row). */
export function PageLoadingSkeleton({ title }: { title?: string }) {
  return (
    <div className="page-skeleton" role="status" aria-live="polite" aria-busy="true" aria-label={title ?? 'Loading page'}>
      <div className="page-skeleton-header">
        <div className="skel skel-title" />
        <div className="skel skel-actions" />
      </div>
      <div className="page-skeleton-kpis">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="skel skel-kpi" />
        ))}
      </div>
      <div className="skel skel-panel" />
      <div className="skel skel-table" />
    </div>
  );
}

/** Compact table skeleton for list bodies. */
export function TableLoadingSkeleton({ rows = 6 }: { rows?: number }) {
  return (
    <div className="table-skeleton" role="status" aria-busy="true" aria-label="Loading table">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="skel skel-row" />
      ))}
    </div>
  );
}
